/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useState } from "react";
import SimpliCitySDK from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isGuid } from "../utils/empty-exists";

const  useSimWebpageImage = (webpage_guid) => {

    const { token } = useAuth();

    const [image,setImage] = useState();
    const [settings,setSettings] = useState();
    const [inProgress,setInProgress] = useState(false);
    const [loaded,setLoaded] = useState(false);

    useEffect(() => {
        const getWebpageImage = async (guid) => {
            setInProgress(true);
            if (isGuid(guid) && !inProgress && !loaded) {
                const result = await SimpliCitySDK.webpage.getWebpageBannerImage(token, guid);
                const image = result?.image;
                const settings = result?.settings;
                setImage(image);
                setSettings(settings);
            }
            setInProgress(false);
            setLoaded(false);
        };
        getWebpageImage(webpage_guid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webpage_guid]);

    return { image, settings, loaded };
};

export { useSimWebpageImage };
